var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTeleTemperatureCritical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20C13.6569 20 15 18.6569 15 17C15 15.3431 13.6569 14 12 14C10.3431 14 9 15.3431 9 17C9 18.6569 10.3431 20 12 20Z",
    fill: "#ff0700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6V15.5",
    stroke: "#ff0700",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1523 1.5C13.3193 1.5 14.4385 1.9639 15.2637 2.78906C16.0888 3.61422 16.5527 4.73345 16.5527 5.90039V13.3623L16.665 13.501C17.4413 14.4553 17.8891 15.6319 17.9463 16.8564L17.9531 17.1016C17.9538 18.0256 17.733 18.9365 17.3096 19.7578C16.8858 20.5796 16.2704 21.2878 15.5166 21.8232C14.7628 22.3587 13.892 22.7064 12.9766 22.8359C12.0611 22.9655 11.1276 22.8736 10.2549 22.5684C9.38226 22.2631 8.59505 21.7529 7.95996 21.0811C7.32505 20.4093 6.86023 19.5953 6.60449 18.707C6.34874 17.8185 6.3095 16.8813 6.49023 15.9746C6.67099 15.0679 7.06665 14.2176 7.64355 13.4951L7.75293 13.3584V5.90039C7.75293 4.73361 8.21609 3.61419 9.04102 2.78906C9.86609 1.96398 10.9855 1.50009 12.1523 1.5Z",
    stroke: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTeleTemperatureCritical);
export default __webpack_public_path__ + "static/media/ic_tele_temperature_critical.8ea978c62db96f12acc75cbc56c4ba46.svg";
export { ForwardRef as ReactComponent };